module.exports = __webpack_public_path__ + "images/pages/kaitori_bonus_cp_lp/february/mainvisual-bg-sp_ae767aa998eed6c75681c73179830a43.png";